/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { ItemsCreators } from '../../../../store/actions/items';

import startPointMainFlowIcon from '../../../../assets/images/ic_builder_start_line.svg';
import startPointSubflowIcon from '../../../../assets/images/icon_subflow.svg';

const mainFlow = {
  type: 'bot',
  icon: startPointMainFlowIcon,
  title: 'Ponto inicial',
};

const subFlow = {
  type: 'groupItem',
  icon: startPointSubflowIcon,
  title: 'Entrada do Grupo',
};

const StartPoint = (props) => {
  const { user, connectors, bot, panCurrent, currentFlow } = props;
  const [currentStartPoint, setCurrentStartPoint] = useState(mainFlow);

  useEffect(() => {
    const { _id, title: blockName } = bot;
    const { id } = currentFlow;
    if (_id && id === '') {
      const { changeCurrentFlow } = props;
      changeCurrentFlow({ id: _id, blockName });
    }
  }, [bot]);

  useEffect(() => {
    const { _id } = bot;
    const { id } = currentFlow;
    if (_id && _id !== '') {
      if (id && _id !== id) {
        setCurrentStartPoint(subFlow);
      } else {
        setCurrentStartPoint(mainFlow);
      }
    }
  }, [currentFlow]);

  useEffect(() => {
    return () => {
      const { changeCurrentFlow } = props;

      setCurrentStartPoint(mainFlow);
      changeCurrentFlow({ id: '', blockName: '' });
    };
  }, []);

  const isRoot = () => {
    return user?.selectedCompany?.claim?.name !== 'Viewer';
  };

  const hasConnector = () => {
    const { id } = currentFlow;
    return connectors.some((connector) => connector.from === id);
  };

  const onClickStartPoint = (event) => {
    if (!hasConnector() && isRoot()) {
      const { activateCreate } = props;
      activateCreate(event, null);
    }
  };

  const getComponentContainerClass = () => {
    return isRoot() ? '' : 'op-user';
  };

  const getComponentContainerStyle = () => {
    return {
      position: 'absolute',
      left: 500 + panCurrent.x,
      top: 50 + panCurrent.y,
    };
  };

  const getBuilderCircleClass = () => {
    if (hasConnector()) {
      return '';
    }

    return isRoot() ? 'pointer' : 'op-user';
  };

  return (
    <div
      className={getComponentContainerClass()}
      style={getComponentContainerStyle()}
    >
      <div id="builder__root">
        <div
          className={`builder__circle noselect ${getBuilderCircleClass()}`}
          onClick={onClickStartPoint}
        >
          <img src={currentStartPoint.icon} alt="" />
          <span>{currentStartPoint.title}</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentFlow: state.items.currentFlow,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...ItemsCreators }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StartPoint)
);
